import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInjection: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"injection"} maskId="square-filled-radius-0-stroke-1-IconInjection"><path d="M21.8555 6.14648L21.1484 6.85352L19.502 5.20703L17.209 7.5L20.8555 11.1465L20.1484 11.8535L18.502 10.207L9.50195 19.207L7.50195 17.207L3.35547 21.3535L2.64844 20.6465L6.79492 16.5L4.79492 14.5L13.7949 5.5L12.1484 3.85352L12.8555 3.14648L16.502 6.79297L18.7949 4.5L17.1484 2.85352L17.8555 2.14648L21.8555 6.14648Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconInjection;
